/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG編集レスポンス
 * @export
 * @interface UpdateGroup200Response
 */
export interface UpdateGroup200Response {
    /**
     * ペイメントグループID
     * @type {number}
     * @memberof UpdateGroup200Response
     */
    groupId: number;
}

/**
 * Check if a given object implements the UpdateGroup200Response interface.
 */
export function instanceOfUpdateGroup200Response(value: object): value is UpdateGroup200Response {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    return true;
}

export function UpdateGroup200ResponseFromJSON(json: any): UpdateGroup200Response {
    return UpdateGroup200ResponseFromJSONTyped(json, false);
}

export function UpdateGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroup200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
    };
}

export function UpdateGroup200ResponseToJSON(json: any): UpdateGroup200Response {
    return UpdateGroup200ResponseToJSONTyped(json, false);
}

export function UpdateGroup200ResponseToJSONTyped(value?: UpdateGroup200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
    };
}

